import React from "react";
import * as S from "./styles";

const FooterActions = ({
    onGoToDetails,
    onDownloadPdf,
    icons,
    isLoadingDownload,
}) => {
    return (
        <S.FooterButtons>
            <S.SecondaryActionButton
                onClick={onGoToDetails}
                type="button"
            >
                {icons?.details}
                Detalhes
            </S.SecondaryActionButton>

            <S.SecondaryActionButton
                variant="danger"
                onClick={onDownloadPdf}
                type="button"
                disabled={isLoadingDownload}
            >
                {icons?.download}
                {isLoadingDownload ? "Baixando..." : "Baixar PDF"}
            </S.SecondaryActionButton>
        </S.FooterButtons>
    );
};

export default FooterActions;